var _defs, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFbGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.462,
    height: 22.078,
    viewBox: "0 0 11.462 22.078",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -8.369,
    y1: -1.193,
    x2: 6.368,
    y2: 1.578,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#0b998e"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.163,
    stopColor: "#27a486"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.389,
    stopColor: "#46b07c"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.609,
    stopColor: "#5db975"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.817,
    stopColor: "#6abe71"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6fc070"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_925",
    "data-name": "Path 925",
    d: "M965.745,101.06h4.074V90.981h3.409l.525-3.946H969.83V84.152a1.51,1.51,0,0,1,1.512-1.512h2.52V79.07l-3.334-.086a4.64,4.64,0,0,0-4.771,4.642v3.4H962.4v3.946h3.356V101.06Z",
    transform: "translate(-962.4 -78.982)",
    fill: "url(#linear-gradient)"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFbGreen);
export default __webpack_public_path__ + "static/media/fbGreen.6314121a449740ea98758356d5db9151.svg";
export { ForwardRef as ReactComponent };